import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-xqyxqk",
  "use": "icon-xqyxqk-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-xqyxqk\"><defs><style type=\"text/css\"></style></defs><path d=\"M934.595 924.661V573.725L700.608 368.817V47.321H115.684v877.34H57.255v58.52h936.13v-58.52z m-292.507 0H174.204v-818.82h467.884z m233.988 0H700.608V462.376l175.378 146.48zM525.14 339.828H291.152v58.43H525.14z m0 175.468H291.152v58.43H525.14z m0 175.468H291.152v58.79H525.14z m292.416 0h-58.429v58.79h58.43z\" p-id=\"50596\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol